import { useState } from "react"
import { Space } from "antd"
import { Title } from "ui/Typography"
import { useTranslation } from "react-i18next"
import BookingDetailsHeader from "./Header"
import BookingDetailsBody from "./Body"
import CrewTab from "./Body/CrewTab"
import DSTab from "ui/DSTab"
import PropTypes from "prop-types"
import { useSelector } from "react-redux"
import useLoaderWatchers from "modules/loader-watchers/hooks/useLoaderWatchers"
import styles from "./index.module.css"

const BookingDetails = ({ isShowTitle = true }) => {
  const { t } = useTranslation()
  const { data } = useSelector((store) => store?.bookings?.clientBookingDetails) || {}
  const [activeTab, setActiveTab] = useState("details")
  useLoaderWatchers({ watchers: ["bookings.clientBookingDetails"] })

  const tabItems = [
    { key: "details", label: t("booking.tabs.details") || "Details" },
    { key: "crew", label: t("booking.tabs.crew") || "Crew" },
    { key: "equipment", label: t("booking.tabs.equipment") || "Equipment" }
  ]

  const renderTabContent = () => {
    switch (activeTab) {
      case "details":
        return <BookingDetailsBody booking={data} />
      case "crew":
        return <CrewTab booking={data} />
      case "equipment":
        return <div>Equipment content coming soon</div>
      default:
        return <BookingDetailsBody booking={data} />
    }
  }

  return (
    <Space direction="vertical" size={32} className="w-full">
      {isShowTitle && <Title level={3}>{t("client.booking_details")}</Title>}
      <BookingDetailsHeader booking={data} className={`${isShowTitle ? "" : styles.bookingdetails}`} />
      <DSTab items={tabItems} activeKey={activeTab} onChange={setActiveTab} />
      {renderTabContent()}
    </Space>
  )
}

BookingDetails.propTypes = {
  isShowTitle: PropTypes.bool
}

export default BookingDetails
